import { useState } from "react";
import { User, Lock } from "react-feather";
import {
  BackgroundLines,
  BackgroundWaves,
  ButtonComp,
  Container,
  Form,
  GlobalStyle,
  HeadingTitle,
  IconWrapper,
  Input,
  InputGroup,
  Line,
  LoginCard,
  Title,
  Wave,
} from "./LoginStyle";
import { message } from "antd";
import { auth } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { authlogin } from "../Store/Authentication";
import { useNavigate } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValidEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
    if (!email || !password) {
      message.warning("Please fill all the fields");
      return;
    }
    if (!isValidEmail(email)) {
      message.error("Please enter a valid email address");
      return;
    }

    try {
      setLoader(true);
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      toast.success("Login successful!");
      dispatch(authlogin(user));
      navigate("/feeds");
    } catch (error) {
      console.log(error, "error");

      toast.error("Invalid credential" || "Authentication failed");
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <GlobalStyle />
      <Container>
        <BackgroundLines>
          {[...Array(10)].map((_, i) => (
            <Line key={i} $index={i} />
          ))}
        </BackgroundLines>
        <BackgroundWaves>
          {[...Array(3)].map((_, i) => (
            <Wave key={i} $index={i} />
          ))}
        </BackgroundWaves>

        {/* Login Form */}
        <LoginCard>
          <HeadingTitle>c template</HeadingTitle>
          <Title>Please Login to admin Dashboard</Title>
          <Form>
            <InputGroup>
              <IconWrapper>
                <User size={18} />
              </IconWrapper>
              <Input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </InputGroup>
            <InputGroup>
              <IconWrapper>
                <Lock size={18} />
              </IconWrapper>
              <Input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </InputGroup>
            <ButtonComp type="submit" loading={loader} onClick={handleSubmit}>
              Login
            </ButtonComp>
          </Form>
        </LoginCard>
      </Container>
    </>
  );
}

export default Login;
